import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetBlogListLoading, EGetBlogListActionType } from './types';

export const getBlogListLoading: () => TGetBlogListLoading = actionGenerator<EGetBlogListActionType.Loading>(
  EGetBlogListActionType.Loading,
);
